const _eventHandlers = {};

export const _addEventListener = (element, event, handler, capture = false) => {
    if (!(event in _eventHandlers)) {
        _eventHandlers[event] = [];
    }
    if (element) {
        _eventHandlers[event].push({ node: element, handler: handler, capture: capture });
        element.addEventListener(event, handler, capture);
    }
};

export const removeAllListeners = (targetNode) => {
    const events = Object.getOwnPropertyNames(_eventHandlers);
    for (let i = 0; i < events.length; i++) {
        removeAllEventListeners(targetNode, events[i]);
    }
};

export const removeAllEventListeners = (targetNode, event = null) => {
    // remove listeners from the matching nodes
    if (isEventListenerRegistered(targetNode, event)) {
        _eventHandlers[event]
            .filter(({ node }) => node === targetNode)
            .forEach(({ node, handler, capture }) => node.removeEventListener(event, handler, capture));
        // update _eventHandlers global
        _eventHandlers[event] = _eventHandlers[event].filter(({ node }) => node !== targetNode);
    }
};

export const isEventListenerRegistered = (targetNode, event = null) => {
    if (typeof _eventHandlers[event] !== "undefined") {
        return _eventHandlers[event].filter(({ node }) => node === targetNode).length > 0;
    }
    return false;
};

export function dispatch(eventName, element = window, detail) {
    element.dispatchEvent(new CustomEvent(eventName, { detail }));
}
